import { Button, notification } from "antd";
import React, { useState } from "react";
import DataProvider from "../../apis";

function getApiMessage(error: unknown): string {
  if (error && typeof error === "object" && "response" in error) {
    const res = (error as { response?: { data?: { message?: string } } }).response;
    if (res?.data?.message) return res.data.message;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong. Please try again.";
}

export default function Passwordotp2(props: any) {
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (inputValue.length > 6) {
      event.target.value = inputValue.slice(0, 6);
    }
  };

  const handleOTP = async () => {
    if (props.otp.length !== 6) {
      api.warning({
        message: "OTP",
        description: "OTP must be six (6) digits.",
      });
      return;
    }

    const email = (props.email || "").trim().toLowerCase();
    if (!email) {
      api.error({
        message: "Error",
        description: "Email is required. Please go back and enter your email.",
      });
      return;
    }

    setLoading(true);
    try {
      const { data } = await DataProvider.verifypasswordotp(email, props.otp);
      setLoading(false);
      if (data.valid) {
        api.success({
          message: "Verified",
          description: "Email address verified. You can now set your new password.",
        });
        props.setEmail(data.email ?? email);
        props.main ? props.setInnerTab(2) : props.setInnerTab(3);
      } else {
        api.error({
          message: "Verification failed",
          description: data.message ?? "The code you entered is invalid or expired. Please try again.",
        });
      }
    } catch (error: unknown) {
      setLoading(false);
      const msg =
        getApiMessage(error) === "ERR_NETWORK"
          ? "Couldn't verify. Check your internet connection and try again."
          : getApiMessage(error);
      api.error({
        message: "Verification failed",
        description: msg,
      });
    }
  };

  return (
    <div className="w-full md:h-[70vh] h-[50vh] flex flex-col justify-start items-start">
      {props.noBack ? null : (
        <Button onClick={() => props.setInnerTab(1)} className="my-2">
          Back
        </Button>
      )}

      <div className="w-full my-2 flex flex-col justify-center items-center p-4">
        <div className="md:w-[40%] w-full">
          <h3 className="font-semibold text-lg">Verify Account</h3>
          <p className="py-2">
            A short code has been sent to your email, please input it below to
            reset your password.
          </p>
          <input
            max={99999}
            type="number"
            value={props.otp}
            onChange={(e) => props.setOtp(e.target.value)}
            placeholder="000000"
            className="rounded-lg bg-white h-12 text-base px-2 outline-none border border-solid border-gray-200 w-full mb-4"
            onInput={handleInput}
          />
          <Button
            type="primary"
            onClick={handleOTP}
            className="bg-[#1A94EC] text-white hover:text-[#1A94EC]"
          >
            {loading ? "Checking..." : "Verify OTP"}
          </Button>
          {props.noBack ? (
            <Button onClick={() => props.setInnerTab(0)} className="mx-2">
              Go Back
            </Button>
          ) : null}
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
